import React from "react";
import "./BottomNav.scss";

const BottomNav = () => {
  return (
    <footer>
      <div className="emoticons1">
        <div className="active1">&#x1F61B;</div>
        <div>&#x1F60D;</div>
        <div>&#x1F60E;</div>
        <div>&#x1F631;</div>
      </div>
    </footer>
  );
};

export default BottomNav;
